

export const colors = {
  clrPurple: "rgb(124, 93, 250)",
  clrPurpleHover: "rgb(146, 119, 255)",
  clrGreen: "rgb(51, 214, 159)",
  clrGreenBg: "rgb(51, 214, 159 , 0.06)",
  clrOrange: "rgb(255, 143, 0)",
  clrOrangeBg: "rgb(255, 143, 0,0.06)",
  clrRed: "rgb(236, 87, 87)",
  clrRedHover: "rgba(255, 151, 151)",
  clrWhite: "rgb(255, 255, 255)",
  clrBlack: "rgb(12, 14, 22)",
  clrAsidBarBg: "rgb(30, 33, 57)",
};

export const darkTheme = {
  clrPrimary: "rgb(255, 255, 255)",
  clrSecondary: "rgb(223, 227, 250)",
  clrSecondaryBg: "rgb(223, 227, 250,0.06)",
  clrBgPrimary: "rgb(20, 22, 37)",
  clrBgSecondary: "rgb(30, 33, 57)",
  clrInvoiceBodyBg :'rgb(37,41,69)',
  clrInvoiceFootBg :'rgb(12,14,22)',
// BLACK BUTTON COLORS
  clrBtnPrimaryBg: "rgb(37,41,69)",
  clrBtnHoverPrimary: "rgb(30, 22, 37)",
  clrBtnHoverBg: "rgb(223, 227, 250)",
};

export const lightTheme = {
  clrPrimary: "rgb(12, 14, 22)",
  clrSecondary: "rgb(126, 136, 195)",
  clrSecondaryBg: "rgb(126, 136, 195,0.06)",
  clrBgPrimary: "rgb(248, 248, 251)",
  clrBgSecondary: "rgb(255, 255, 255)",
  clrInvoiceBodyBg :"rgba(249, 250, 254)",
  clrInvoiceFootBg :'rgb(55,59,83)',

  // BLACK BUTTON COLORS
  clrBtnPrimaryBg: "rgba(249, 250, 254)",
  clrBtnHoverPrimary: "rgb(30, 33, 57)",
  clrBtnHoverBg: "rgba(223, 227, 250)",
};
